import React from "react";
var __jsx = React.createElement;
import AllUspsItem from "@/pages/homePageV2/homePageComponents/components/Usps/AllUspsItem";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useMemo } from "react";
var UspsLearnMoreModal = function UspsLearnMoreModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong,
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var allUspsPopupItems = useMemo(function () {
    return [{
      key: "allUsps1",
      src: "/assets/images/usps/days.svg",
      title: tShort("allUspsModal/item_one_title", {
        ns: "web_home"
      }),
      description: tLong("allUspsModal/item_one_description", {
        ns: "web_home"
      })
    }, {
      key: "allUsps2",
      src: "/assets/images/usps/whiteWarranty.svg",
      title: tShort("allUspsModal/item_two_title", {
        ns: "web_home"
      }),
      description: tLong("allUspsModal/item_two_description", {
        ns: "web_home"
      }) //todo
    }, {
      key: "allUsps3",
      src: "/assets/images/usps/checked.svg",
      title: tShort("allUspsModal/item_three_title", {
        ns: "web_home"
      }),
      description: tLong("allUspsModal/item_three_description", {
        ns: "web_home"
      })
    }, {
      key: "allUsps4",
      src: "/assets/images/usps/new.svg",
      title: tShort("allUspsModal/item_four_title", {
        ns: "web_home"
      }),
      description: tLong("allUspsModal/item_four_description", {
        ns: "web_home"
      })
    }];
  }, [tShort, tLong]);
  return /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4 mb-8 mt-4 justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-64 h-px bg-gradient-to-r from-transparent  to-primary max-w-16 transform rotate-180 en:rotate-0"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "text-primary text-center text-xl font-bold"
  }, tShort("allUspsModal/main_title", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-64 h-px bg-gradient-to-l from-primary  to-transparent max-w-16 en:rotate-180"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 mb-8 "
  }, allUspsPopupItems.map(function (item) {
    return /*#__PURE__*/React.createElement(AllUspsItem, {
      key: item.key,
      src: item.src,
      title: item.title,
      description: item.description
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/car-purchase-terms-conditions"),
    className: "text-center text-[#6D7A8D] text-sm font-medium underline cursor-pointer hover:text-primary transition-colors duration-200 ease-in active:text-[#6D7A8D] lg:text-base"
  }, t("apply_terms_conditions", {
    ns: "web_post_view"
  }))));
};
export default UspsLearnMoreModal;